import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent,
  setAnalyticsCollectionEnabled,
  initializeAnalytics,
} from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCTi3t48d2etQItFMZzBkPQeiAYt6tS7qc",
  authDomain: "pet-pulse-web-d4945.firebaseapp.com",
  projectId: "pet-pulse-web-d4945",
  storageBucket: "pet-pulse-web-d4945.firebasestorage.app",
  messagingSenderId: "622326613790",
  appId: "1:622326613790:web:f3a032c820c0d0ce182b0f",
  measurementId: "G-S4GFW44DVP",
};

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
export const firebaseDB = getFirestore(firebaseApp);

const isDev = process.env.NODE_ENV && process.env.NODE_ENV === "development";
setAnalyticsCollectionEnabled(analytics, !isDev);

export { firebaseApp, initializeAnalytics, logEvent };
